export default "__VITE_ASSET__BxpQ4iQQ__"